import type {ReactElement} from 'react';
import React from 'react';
import {DigitalSignageSubPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/digital-signage-sub-panel/digital-signage-sub-panel';
import type {PublishingFugoPanelProps} from './publishing-fugo-panel.types';
import {getProductUsed} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel-library';

export function PublishingFugoPanel({...props}: PublishingFugoPanelProps): ReactElement<any> {
  const productUsed = getProductUsed();
  const fugoLink = `https://www.fugo.ai/pmw?designId=${window.PMW.util.escapeHTML(productUsed?.posterId || '')}`;

  return (
    <DigitalSignageSubPanel
      panelHeading={window.i18next.t('pmwjs_fugo')}
      heading={window.i18next.t('pmwjs_fugo_digital_signage')}
      subheading={window.i18next.t('pmwjs_fugo_desc')}
      showButton
      onClose={props.onClose}
      buttonText={window.i18next.t('pmwjs_go_to_fugo')}
      onClick={() => {
        window.open(fugoLink, '_blank');
      }}
      imgSrc="publishing-fugo.png"
    />
  );
}
